import { Text } from "@chakra-ui/react";
import type { FormSuccessMessageProps } from "./FormSuccessMessage.d";

const FormSuccessMessage = ({ text }: FormSuccessMessageProps) => (
  <Text fontSize="lg" color="success.500" mt={4}>
    {text}
  </Text>
);

export default FormSuccessMessage;
